export default __webpack_public_path__ + "static/newsletterbanner-127c1cc7a0c77bffe0b90d44ce2876b4.jpg";